import { render, staticRenderFns } from "./add-attribute.vue?vue&type=template&id=8cd0654c&"
import script from "./add-attribute.vue?vue&type=script&lang=js&"
export * from "./add-attribute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports